<div class="flex w-full flex-row py-2">
    <!-- ticket contents-->
    <div
        class="var-app-light-dark:rounded-lg var-app-light-dark:border-2 var-app-light-dark:border-solid var-app-light:border-black var-app-light:border-opacity-10 var-app-dark:border-contrast-yellow var-app-light-dark:p-2 var-app-light:bg-grey-white_smoke orb-app-light-dark:rounded-lg orb-app-light-dark:border-2 orb-app-light-dark:border-solid orb-app-light:border-black orb-app-light:border-opacity-10 orb-app-dark:border-contrast-yellow orb-app-light-dark:p-2 orb-app-light:bg-grey-white_smoke flex w-full flex-col">
        <div class="flex w-full items-center gap-2">
            <div class="flex items-center" *ngIf="env.PURCHASE_FLOW?.SHOW_TICKET_ICON_IN_SHOPPING_CART === true">
                <ng-container [ngSwitch]="ticket?.typeOfProduct?.code">
                    <!-- SINGLE group -->
                    <ng-container *ngSwitchCase="ProductCode.SINGLE">
                        <mat-icon class="ticket-icon" aria-hidden="true" svgIcon="single"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.SINGLE_TICKET_GROUP">
                        <mat-icon class="ticket-icon" aria-hidden="true" svgIcon="single"></mat-icon>
                    </ng-container>

                    <!-- PERIOD group -->
                    <ng-container *ngSwitchCase="ProductCode.PERIOD">
                        <mat-icon class="ticket-icon" aria-hidden="true" svgIcon="period"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.PERIOD_PASS">
                        <mat-icon class="ticket-icon" aria-hidden="true" svgIcon="period"></mat-icon>
                    </ng-container>

                    <!-- BOOKLET -->
                    <ng-container *ngSwitchCase="ProductCode.BOOKLET">
                        <mat-icon class="ticket-icon" aria-hidden="true" svgIcon="booklet"></mat-icon>
                    </ng-container>

                    <!-- MULTI group -->
                    <ng-container *ngSwitchCase="ProductCode.MULTI_JOURNEY">
                        <mat-icon
                            class="logo-category-multi-trip ticket-icon"
                            aria-hidden="true"
                            svgIcon="joint_ticket"></mat-icon>
                    </ng-container>
                    <ng-container *ngSwitchCase="ProductCode.MULTI_TRIP">
                        <mat-icon
                            class="logo-category-multi-trip ticket-icon"
                            aria-hidden="true"
                            svgIcon="joint_ticket"></mat-icon>
                    </ng-container>

                    <!-- JOINT -->
                    <ng-container *ngSwitchCase="ProductCode.JOINT_TICKET">
                        <mat-icon
                            class="logo-category-multi-trip ticket-icon"
                            aria-hidden="true"
                            svgIcon="joint_ticket"></mat-icon>
                    </ng-container>

                    <!-- DEFAULT -->
                    <ng-container *ngSwitchDefault>
                        <mat-icon class="ticket-icon" aria-hidden="true" svgIcon="single"></mat-icon>
                    </ng-container>
                </ng-container>
                <!-- END ICONS -->
            </div>

            <!-- TEXT (flexible) -->
            <div class="flex flex-1 flex-col">
                <h3 class="w-full text-base font-bold">
                    {{ count }} × {{ ticket?.name | translateObjectField: null : currentLanguage }}
                </h3>
                <p class="w-full text-sm" *ngIf="ticket.isSingleTicketGroup">{{ ticket.ticketTypes }}</p>
                <p class="text-xs">{{ ticket?.description }}</p>
                <p class="text-xs" *ngIf="hasFixedValidityRange(); else activationInfo">
                    {{ 'TICKET_SUMMARY_V2_VALIDITY' | translate }}:
                    {{ fixedValidityRangeStart() | date: 'dd.MM.yyyy HH:mm' }} -
                    {{ fixedValidityRangeEnd() | date: 'dd.MM.yyyy HH:mm' }}
                </p>
                <ng-template #activationInfo>
                    <p class="text-xs" *ngIf="ticket?.starting; else manualActivation">
                        {{ 'TICKET_WILL_BE_ACTIVATED_ON' | translate }}:
                        <ng-container *ngIf="isActivateNow(); else scheduledActivation">
                            {{ 'ACTIVATE_TICKET_PURCHASE' | translate }}
                        </ng-container>
                        <ng-template #scheduledActivation>
                            {{ ticket.starting | date: env.ACTIVATION_DATE_DISPLAY_FORMAT }}
                        </ng-template>
                    </p>
                </ng-template>
                <ng-template #manualActivation>
                    <p class="text-xs">
                        {{ 'TICKET_WILL_BE_ACTIVATED_ON' | translate }}: {{ 'ACTIVATE_TICKET_MANUAL' | translate }}
                    </p>
                </ng-template>
                <p class="text-xs" *ngIf="env.PURCHASE_FLOW?.TICKET_CONF?.SHOPPING_CART?.ZONES_IN_TICKET_NAME">
                    {{ ticket?.zonesString }}
                </p>
                <p class="py-1 text-xs" [ngSwitch]="ticket.cardType">
                    <ng-container *ngSwitchCase="cardType.UTN">
                        {{ 'MEDIUM_CARD_WITH_VALUE' | translate: { value: ticket.cardId } }}
                    </ng-container>
                    <ng-container *ngSwitchCase="cardType.UTN2">
                        {{ 'MEDIUM_CARD_WITH_VALUE' | translate: { value: ticket.cardId } }}
                    </ng-container>
                    <ng-container *ngSwitchCase="cardType.PERSON">
                        {{ 'MEDIUM_PERSONAL_CODE_WITH_VALUE' | translate: { value: ticket.cardId } }}
                    </ng-container>
                    <ng-container *ngSwitchCase="cardType.EMAIL">
                        {{ 'MEDIUM_EMAIL_WITH_VALUE' | translate: { value: ticket.email } }}
                    </ng-container>
                </p>
            </div>

            <!-- PRICE -->
            <div class="min-w-[6rem] text-right">
                <ng-container *ngIf="ticketValueCodes.length > 0; else regularPrice">
                    <p class="text-sm line-through opacity-60">
                        {{ getPriceString(totalPrice) }} {{ env.WMB.CURRENCY || ticket.price.currency || currency }}
                    </p>
                    <p class="text-base font-bold text-secondary dark:text-contrast-yellow">
                        {{ getPriceString(totalPrice - ticket.price.discountAmount) }}
                        {{ env.WMB.CURRENCY || ticket.price.currency || currency }}
                    </p>
                </ng-container>
                <ng-template #regularPrice>
                    <p class="min-w-fit text-base font-bold dark:text-contrast-yellow">
                        {{ getPriceString(totalPrice) }} {{ env.WMB.CURRENCY || ticket.price.currency || currency }}
                    </p>
                </ng-template>
            </div>
        </div>

        <div
            *ngIf="
                env.PURCHASE_FLOW?.FREE_TRAVEL_MESSAGE_IN_DESCRIPTION &&
                (currentProductArea()?.description | translateObjectField: null : currentLanguage)
            ">
            <ridango-ui-alert type="info">
                <div>
                    {{ currentProductArea().description | translateObjectField: null : currentLanguage }}
                </div>
            </ridango-ui-alert>
        </div>

        <div class="border-t border-solid py-2 dark:border-contrast-yellow" *ngIf="ticketValueCodes.length > 0">
            <div
                class="flex items-center justify-between gap-4"
                *ngFor="let code of ticketValueCodes"
                [ngClass]="{
                    'ml-10': !removeMode,
                    'ml-0': removeMode
                }">
                <ion-button
                    class="next-button"
                    *ngIf="removeMode"
                    (click)="openDeleteValueCodeModal(code)"
                    fill="clear">
                    <ion-icon
                        class="orb-app-light:text-danger text-primary dark:text-contrast-yellow"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/cart/icon-delete.svg"></ion-icon>
                </ion-button>
                <div class="flex flex-1 items-center gap-2">
                    <span
                        class="rounded-full bg-secondary px-3 py-1 text-xs font-medium text-white dark:bg-contrast-yellow dark:text-contrast-black">
                        {{ code.serialNumber }}
                    </span>
                    <span class="text-xs text-gray-600 dark:text-contrast-yellow" *ngIf="code.discountValue">
                        -{{ code.discountValue / 10 }}%
                    </span>
                </div>
                <p class="text-sm font-semibold text-secondary dark:text-contrast-yellow">
                    -{{ getPriceString(ticket.price.discountAmount) }}
                    {{ env.WMB?.CURRENCY || ticket.price.currency || currency }}
                </p>
            </div>
        </div>
    </div>
</div>

<ion-modal
    class="delete-ticket-modal"
    [isOpen]="deleteTicketModalOpen"
    [silentLiveAnnouncer]="true"
    (didDismiss)="closeDeleteTicketModal()"
    ridangoAppTrapFocus>
    <ng-template>
        <div
            class="flex-column flex max-h-[85vh] dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="relative flex h-16 items-center justify-center px-4 font-bold">
                {{ 'CART_REMOVE_SELECTED_PRODUCT' | translate }}
            </div>
            <mat-divider class="dark:bg-contrast-yellow"></mat-divider>
            <div class="p-4">
                <p>{{ ticket?.name | translateObjectField: null : currentLanguage }}</p>
                <p class="bold text-xs">{{ ticket?.description | translateObjectField: null : currentLanguage }}</p>
                <div class="flex-align-center flex justify-between py-2">
                    <p>{{ count }} × {{ 'CART_TICKET_LABEL' | translate }}</p>
                    <p class="text-base font-bold">
                        {{ getPriceString(totalPrice) }}
                        {{ env.WMB.CURRENCY || ticket.price.currency || currency }}
                    </p>
                </div>
            </div>

            <mat-divider class="dark:bg-contrast-yellow"></mat-divider>

            <div class="p-4">
                <ion-button
                    class="m-0 w-full rounded-lg bg-danger dark:bg-contrast-black"
                    [attr.aria-label]="'CART_REMOVE_TICKET_BUTTON' | translate"
                    (click)="handleDeleteClicked()"
                    ridangoAutofocus
                    size="large"
                    slot="end"
                    color="none">
                    <ion-label class="text-base font-bold normal-case text-white">
                        {{ 'CART_REMOVE_TICKET_BUTTON' | translate }}
                    </ion-label>
                </ion-button>

                <ion-button
                    class="m-0 w-full"
                    [attr.aria-label]="'CART_KEEP_THIS_PRODUCT_IN_CART_BUTTON' | translate"
                    (click)="closeDeleteTicketModal()"
                    size="large"
                    fill="clear"
                    color="secondary">
                    <ion-icon
                        class="text-35xl text-secondary dark:text-contrast-yellow"
                        aria-hidden="true"
                        src="{{ assetsPath$ | async }}/img/back.svg">
                    </ion-icon>
                    <ion-label
                        class="orb-app-light-dark:font-semibold orb-app-light:text-secondary vl-app-light:text-[#108097] vl-app-light:font-semibold sr-app-light:font-semibold text-base font-medium normal-case">
                        {{ 'CART_KEEP_THIS_PRODUCT_IN_CART_BUTTON' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </ng-template>
</ion-modal>
